import React from 'react';

// Material UI
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';

// Styles
import useStyles from './styles';

const Processing: React.FC = () => {
  const classes = useStyles();

  return (
    <Grid
      container
      justifyContent='center'
      alignItems='center'
      className={classes.gridContainer}>
      <Grid
        item
        lg={12}
        md={12}
        sm={12}
        xl={12}
        xs={12}
        className={classes.loading}>
        <CircularProgress
          classes={{
            root: classes.progress,
          }}
        />
      </Grid>

      <Grid item lg={12} xl={12} md={12} sm={12} xs={12}>
        <Typography color='primary' className={classes.text}>
          Processando...
        </Typography>
      </Grid>
    </Grid>
  );
};

export { Processing };
export default Processing;
